import React, { useEffect } from 'react';
import { Checkbox, Grid, Input, Select } from 'semantic-ui-react';
import useFetchTable from '../../../hooks/useFetchTable';
import FiltersComponent from '../../../components/FiltersComponent';
import CustomTable from '../../../components/CustomTable/CustomTable';
import TableStats from '../../../components/TableStats';
import { BooleanCell, StatusCell } from '../../../components/CustomCell';
import SendNotificationModal from '../../../components/SendNotificationModal';
import FileUploadButton from '../../../components/FileUploadButton';
import UserCard from '../../Cards/UserCard';
import { url } from '../../../shared/URL';
import {
  taxStatusOptions,
  legalStructureOptions,
  userStatusOptions,
} from '../../../shared/constants';

const UsersPage = () => {
  const fetchTable = useFetchTable(url.getUsers);

  useEffect(() => {
    if (fetchTable.table.content) {
      const updatedContent = fetchTable.table.content.map((user) => {
        if (user.legal && user.responsible) {
          const [surname, name, patronymic] = user.responsible.split(' ');
          return {
            ...user,
            surname: surname || '',
            username: name || '',
            patronymic: patronymic || '',
            surnameWithInitials: user.responsible || '',
          };
        }
        return user;
      });

      fetchTable.table.content = updatedContent;
    }
  }, [fetchTable.table.content]);

  return (
    <div className="page table-page">
      <h1 className="page__header">Список пользователей</h1>
      <Grid stackable>
        <Grid.Row>
          <Grid.Column className="table-page__stats">
            <TableStats totalElements={fetchTable.totalElements} />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={3}>
            <FiltersComponent
              applyFilters={fetchTable._apply}
              totalElements={fetchTable.totalElements}
              render={SendNotificationModal}
            >
              <Input
                type="text"
                name="surnameWithInitials"
                placeholder="ФИО пользователя"
              />
              <Input type="number" name="mobile" placeholder="Номер телефона" />
              <Select
                placeholder="Статус пользователя"
                options={userStatusOptions}
                name="status"
                clearable
                multiple
              />
              <Select
                placeholder="Организационно-правовая форма"
                options={legalStructureOptions}
                name="legal"
                clearable
              />
              <Select
                placeholder="Статус ФНС"
                options={taxStatusOptions}
                name="taxStatus"
                clearable
                multiple
              />
              <Checkbox name="locked" label="Пользователь заблокирован" />
              <Checkbox name="taxLocked" label="Вывод баллов заблокирован" />
            </FiltersComponent>
            <FileUploadButton
              url={url.addBonusesToList}
              buttonName={'Начислить баллы по списку'}
              update={fetchTable._fetch}
            />
          </Grid.Column>
          <Grid.Column width={13}>
            <CustomTable
              table={fetchTable}
              columns={columns}
              CardComponent={UserCard}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  );
};

export default UsersPage;

const columns = [
  { Header: 'ФИО пользователя', accessor: 'surnameWithInitials' },
  { Header: 'Номер телефона', accessor: 'mobile' },
  {
    Header: 'Статус пользователя',
    accessor: 'status',
    Cell: (row) => StatusCell(row, userStatusOptions),
  },
  {
    Header: 'Статус ФНС',
    accessor: 'taxStatus',
    Cell: (row) => StatusCell(row, taxStatusOptions),
  },
  {
    Header: 'Блокировка пользователя',
    accessor: 'locked',
    Cell: (row) => BooleanCell(row),
  },
  {
    Header: 'Блокировка вывода баллов',
    accessor: 'taxLocked',
    Cell: (row) => BooleanCell(row),
  },
  { Header: 'Начисленные баллы', accessor: 'chargedBonus' },
  { Header: 'Выведенные баллы', accessor: 'dischargedBonus' },
];
